module.exports = "<symbol id=\"tt-icon-checkbox--off\" viewBox=\"0 0 32 32\"><path d=\"M28 0H4C1.8 0 0 1.8 0 4v24c0 2.2 1.8 4 4 4h24c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4zm0 28H4V4h24v24z\" xmlns=\"http://www.w3.org/2000/svg\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/Rdhcya1h7lLN3rcsite/assets/svg/pdp-page/checkbox--off.svg
// module id = 250
// module chunks = 10